(function () {
  'use strict';

  var canvas = document.getElementById('desktop-canvas');
  var bootstrap = document.getElementById('page-bootstrap');
  var taskbarItems = document.getElementById('taskbar-items');
  if (!canvas) return;

  var openWindows = new Map();
  var activationStack = [];
  var activeId = null;
  var zIndex = 1000;
  var drag = null;
  var opening = new Set();
  var boundProductForms = new WeakSet();
  var TASKBAR_H = 40;

  var ICON_KEYS = {
    '/': 'home',
    '/products/ruhigbox': 'product',
    '/pages/hakkinda': 'about',
    '/pages/yorumlar': 'reviews',
    '/pages/iletisim': 'contact',
    '/cart': 'cart',
    '/search': 'search'
  };

  var NAV_ITEMS = [
    { url: '/', title: 'Ana Sayfa' },
    { url: '/products/ruhigbox', title: 'Bleib Ruhig Box' },
    { url: '/pages/hakkinda', title: 'Hakkında' },
    { url: '/pages/yorumlar', title: 'Yorumlar' },
    { url: '/pages/iletisim', title: 'İletişim' },
    { url: '/cart', title: 'Sepet' },
    { url: '/search', title: 'Ara' }
  ];

  function getIconForUrl(url) {
    var key = ICON_KEYS[normalizeUrl(url)] || 'home';
    return (window.WIN98 && window.WIN98.icons && window.WIN98.icons[key]) || '';
  }

  function getDisplayTitle(url) {
    return defaultTitle(url);
  }

  function taskbarHeight() {
    var tb = document.querySelector('.taskbar');
    return tb ? tb.offsetHeight : TASKBAR_H;
  }

  function urlToId(url) {
    var path = new URL(url, location.origin).pathname.replace(/\/+$/, '') || '/';
    if (path === '/') return 'home';
    return 'win' + path.replace(/\//g, '-');
  }

  function normalizeUrl(url) {
    return new URL(url, location.origin).pathname;
  }

  function getWinSizeClass(url) {
    var path = normalizeUrl(url);
    if (path.indexOf('/products/') === 0 || path === '/cart') return 'window--wide';
    if (path === '/pages/hakkinda' || path === '/pages/iletisim') return 'window--narrow';
    return '';
  }

  function defaultTitle(url) {
    var map = {
      '/': 'Ana Sayfa',
      '/pages/hakkinda': 'Hakkında',
      '/pages/yorumlar': 'Yorumlar',
      '/pages/iletisim': 'İletişim',
      '/cart': 'Sepet',
      '/search': 'Ara',
      '/products/ruhigbox': 'Bleib Ruhig Box'
    };
    return map[normalizeUrl(url)] || 'Pencere';
  }

  function isMobileView() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function updateMobileLauncher() {
    var icons = document.querySelector('.desktop-icons');
    if (!icons || !isMobileView()) return;
    if (openWindows.size > 0) {
      icons.classList.add('desktop-icons--dismissed');
      document.body.classList.add('has-open-windows');
    } else {
      icons.classList.remove('desktop-icons--dismissed');
      document.body.classList.remove('has-open-windows');
    }
  }

  function layoutMobileWindow(el) {
    if (!isMobileView() || !el) return;
    el.style.top = '0';
    el.style.left = '4px';
    el.style.width = 'calc(100% - 8px)';
    el.style.height = 'calc(100% - 4px)';
    el.style.maxHeight = 'none';
  }

  function cascadeOffset() {
    var n = openWindows.size % 6;
    return { top: 12 + n * 22, left: 8 + n * 22 };
  }

  function setActive(id) {
    activationStack = activationStack.filter(function (x) {
      return x !== id;
    });
    activationStack.push(id);

    openWindows.forEach(function (win, winId) {
      win.el.classList.toggle('active', winId === id);
      win.el.classList.toggle('inactive', winId !== id);
      var tb = document.querySelector('[data-window="' + winId + '"]');
      if (tb) tb.classList.toggle('active', winId === id);
    });
    activeId = id;
    var w = openWindows.get(id);
    if (w) {
      w.el.style.zIndex = String(++zIndex);
      layoutMobileWindow(w.el);
    }
    updateMobileLauncher();
  }

  function addTaskbarItem(id, title) {
    if (!taskbarItems || document.querySelector('[data-window="' + id + '"]')) return;
    var item = document.createElement('button');
    item.type = 'button';
    item.className = 'taskbar-item';
    item.setAttribute('data-window', id);
    item.textContent = title;
    item.addEventListener('click', function () {
      toggleWindow(id);
    });
    taskbarItems.appendChild(item);
  }

  function removeTaskbarItem(id) {
    var item = document.querySelector('[data-window="' + id + '"]');
    if (item) item.remove();
  }

  function toggleWindow(id) {
    var w = openWindows.get(id);
    if (!w) return;
    if (w.el.classList.contains('is-minimized') && activeId === id) {
      w.el.classList.remove('is-minimized');
      setActive(id);
      return;
    }
    if (!w.el.classList.contains('is-minimized') && activeId === id) {
      w.el.classList.add('is-minimized');
      w.el.classList.remove('active');
      return;
    }
    w.el.classList.remove('is-minimized');
    setActive(id);
  }

  function closeWindow(id) {
    var w = openWindows.get(id);
    if (!w) return;
    w.el.remove();
    openWindows.delete(id);
    removeTaskbarItem(id);
    activationStack = activationStack.filter(function (x) {
      return x !== id;
    });
    if (activeId === id) {
      var next = activationStack.length ? activationStack[activationStack.length - 1] : null;
      if (next && openWindows.has(next)) {
        openWindows.get(next).el.classList.remove('is-minimized');
        setActive(next);
      } else {
        activeId = null;
        updateMobileLauncher();
      }
    } else {
      updateMobileLauncher();
    }
  }

  function minimizeWindow(id) {
    var w = openWindows.get(id);
    if (!w) return;
    w.el.classList.add('is-minimized');
    w.el.classList.remove('active');
    var tb = document.querySelector('[data-window="' + id + '"]');
    if (tb) tb.classList.remove('active');
  }

  function maximizeWindow(id) {
    var w = openWindows.get(id);
    if (!w) return;
    var el = w.el;
    var rect = canvas.getBoundingClientRect();
    if (el.classList.contains('is-maximized')) {
      el.classList.remove('is-maximized');
      el.style.width = el.dataset.w || '';
      el.style.height = el.dataset.h || '';
      el.style.top = el.dataset.t || '';
      el.style.left = el.dataset.l || '';
    } else {
      el.dataset.w = el.style.width;
      el.dataset.h = el.style.height;
      el.dataset.t = el.style.top;
      el.dataset.l = el.style.left;
      el.classList.add('is-maximized');
      el.style.top = '0';
      el.style.left = '0';
      el.style.width = rect.width + 'px';
      el.style.height = rect.height + 'px';
    }
    setActive(id);
  }

  function buildExplorerChrome(url) {
    var icon = getIconForUrl(url);
    var displayTitle = getDisplayTitle(url);

    var toolbarHtml = NAV_ITEMS.map(function (item) {
      var active = normalizeUrl(item.url) === normalizeUrl(url) ? ' is-active' : '';
      var iurl = getIconForUrl(item.url);
      return (
        '<button type="button" class="explorer-tool' +
        active +
        '" data-open-url="' +
        item.url +
        '" data-open-title="' +
        item.title +
        '">' +
        '<img src="' +
        iurl +
        '" width="16" height="16" alt="">' +
        '<span>' +
        item.title +
        '</span></button>'
      );
    }).join('');

    return (
      '<div class="explorer-chrome">' +
      '<div class="explorer-toolbar">' +
      toolbarHtml +
      '</div>' +
      '<div class="explorer-address">' +
      '<span class="explorer-address__label"><span class="u">A</span>ddress</span>' +
      '<div class="explorer-address__combo">' +
      '<div class="explorer-address__field">' +
      '<img class="explorer-address__icon" src="' +
      icon +
      '" width="16" height="16" alt="">' +
      '<span class="explorer-address__text">' +
      displayTitle +
      '</span>' +
      '</div>' +
      '<button type="button" class="explorer-address__drop" tabindex="-1" aria-hidden="true">&#9660;</button>' +
      '</div></div></div>'
    );
  }

  function setTitleBarIcon(el, url) {
    var titleEl = el.querySelector('.window-title');
    if (!titleEl) return;
    var icon = getIconForUrl(url);
    var existing = titleEl.querySelector('.titlebar-page-icon');
    if (existing) existing.remove();
    if (!icon) return;
    var img = document.createElement('img');
    img.className = 'titlebar-page-icon';
    img.src = icon;
    img.width = 16;
    img.height = 16;
    img.alt = '';
    titleEl.insertBefore(img, titleEl.firstChild);
  }

  function enhanceWindowChrome(el, url) {
    var header = el.querySelector('.window-header');
    if (!header) return;
    var old = el.querySelector('.explorer-chrome');
    if (old) old.remove();
    header.insertAdjacentHTML('afterend', buildExplorerChrome(url));
  }

  function wireWindowControls(el, id) {
    el.addEventListener('mousedown', function () {
      setActive(id);
    });
    el.addEventListener('touchstart', function () {
      setActive(id);
    }, { passive: true });
  }

  function handleWindowControlClick(btn) {
    var win = btn.closest('.window');
    if (!win || !win.id) return;
    var id = win.id.replace('-window', '');
    var t = (btn.textContent || '').trim();
    if (t === '_' || t === '−') minimizeWindow(id);
    else if (t.indexOf('□') !== -1) maximizeWindow(id);
    else closeWindow(id);
  }

  function initQtySteppers(root) {
    root.querySelectorAll('.qty').forEach(function (wrap) {
      if (wrap.dataset.qtyReady) return;
      wrap.dataset.qtyReady = '1';
      var input = wrap.querySelector('.qty__input');
      wrap.addEventListener('click', function (e) {
        var t = e.target.closest('[data-qty]');
        if (!t || !input) return;
        var val = parseInt(input.value, 10) || 1;
        if (t.dataset.qty === 'plus') val += 1;
        else val = Math.max(1, val - 1);
        input.value = val;
      });
    });
  }

  function handleProductAddSubmit(e) {
    var form = e.target;
    if (!form || form.id !== 'product-form') return;
    if (!canvas.contains(form)) return;
    if (!e.submitter || e.submitter.name !== 'add') return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (form.dataset.submitting === '1') return;
    form.dataset.submitting = '1';
    var btn = e.submitter;
    btn.disabled = true;
    var fd = new FormData(form);
    fetch(shopifyPath('cart/add.js'), { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        return updateCartBadge().then(function () {
          var cartId = urlToId('/cart');
          if (openWindows.has(cartId)) {
            return refreshWindowContent(cartId, '/cart');
          }
          return openWindow('/cart', 'Sepet');
        });
      })
      .catch(function () {
        form.dataset.submitting = '0';
        btn.disabled = false;
        form.submit();
      })
      .finally(function () {
        form.dataset.submitting = '0';
        btn.disabled = false;
      });
  }

  function initProductForm(root) {
    var form = root.querySelector('#product-form');
    if (!form || boundProductForms.has(form)) return;
    boundProductForms.add(form);

    var variants = [];
    var jsonEl = form.querySelector('.product-variants-json');
    if (jsonEl) {
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (e) {}
    }
    var idInput = form.querySelector('input[name="id"]');
    var selects = form.querySelectorAll('select[name^="options"]');
    if (variants.length && selects.length && idInput) {
      function updateVariant() {
        var chosen = Array.prototype.map.call(selects, function (s) {
          return s.value;
        });
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === chosen[i];
          });
        });
        if (match) idInput.value = match.id;
      }
      selects.forEach(function (s) {
        s.addEventListener('change', updateVariant);
      });
    }
  }

  function initWindowContent(root) {
    initQtySteppers(root);
    initProductForm(root);
  }

  function shopifyPath(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (path.charAt(0) === '/') path = path.slice(1);
    return root + path;
  }

  function extractWindowFromDoc(doc) {
    var bootstrapEl = doc.getElementById('page-bootstrap');
    if (bootstrapEl) {
      var bw = bootstrapEl.querySelector('.window');
      if (bw) return bw.cloneNode(true);
      if (bootstrapEl.firstElementChild) return bootstrapEl.firstElementChild.cloneNode(true);
    }
    var main = doc.getElementById('main-content');
    if (main) {
      var mw = main.querySelector('.window');
      if (mw) return mw.cloneNode(true);
    }
    return null;
  }

  function fetchWindowHtml(url) {
    return fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return extractWindowFromDoc(doc);
      });
  }

  function refreshWindowContent(id, url) {
    return fetchWindowHtml(url).then(function (node) {
      var w = openWindows.get(id);
      if (!w || !node) return null;
      var newContent = node.querySelector('.window-content');
      var oldContent = w.el.querySelector('.window-content');
      if (newContent && oldContent) {
        oldContent.innerHTML = newContent.innerHTML;
      }
      enhanceWindowChrome(w.el, url);
      setTitleBarIcon(w.el, url);
      initWindowContent(w.el);
      setActive(id);
      return w.el;
    });
  }

  function positionWindow(el, url) {
    var sizeClass = getWinSizeClass(url);
    el.classList.add('visible');
    if (sizeClass) el.classList.add(sizeClass);
    if (isMobileView()) {
      layoutMobileWindow(el);
      return;
    }
    var off = cascadeOffset();
    el.style.top = off.top + 'px';
    el.style.left = off.left + 'px';
  }

  function mountWindow(el, id, url, title) {
    el.id = id + '-window';
    el.dataset.url = url;
    if (!el.querySelector('.window-header')) {
      el.innerHTML =
        '<div class="window-header"><span class="window-title">' +
        title +
        '</span><div class="window-controls"><button type="button" class="window-button">_</button><button type="button" class="window-button">&#9633;</button><button type="button" class="window-button">&times;</button></div></div><div class="window-content">' +
        el.innerHTML +
        '</div>';
    } else {
      var titleEl = el.querySelector('.window-title');
      if (titleEl && title) titleEl.textContent = title;
    }
    positionWindow(el, url);
    enhanceWindowChrome(el, url);
    setTitleBarIcon(el, url);
    canvas.appendChild(el);
    wireWindowControls(el, id);
    initWindowContent(el);
    openWindows.set(id, { el: el, url: url, title: title });
    addTaskbarItem(id, title.split('—')[0].trim());
    setActive(id);
    return el;
  }

  function openWindow(url, title, htmlNode, options) {
    options = options || {};
    url = normalizeUrl(url);
    var id = urlToId(url);

    if (openWindows.has(id)) {
      var existing = openWindows.get(id);
      existing.el.classList.remove('is-minimized');
      setActive(id);
      if (normalizeUrl(url) === '/cart') {
        return refreshWindowContent(id, url);
      }
      return Promise.resolve(existing.el);
    }

    if (opening.has(id)) {
      return Promise.resolve(null);
    }
    opening.add(id);

    function done() {
      opening.delete(id);
    }

    if (htmlNode) {
      mountWindow(htmlNode, id, url, title || defaultTitle(url));
      if (options.replace) history.replaceState({ id: id, url: url }, '', url);
      else history.pushState({ id: id, url: url }, '', url);
      done();
      return Promise.resolve(htmlNode);
    }

    return fetchWindowHtml(url)
      .then(function (node) {
        if (!node) throw new Error('empty');
        var t =
          (node.querySelector('.window-title') &&
            node.querySelector('.window-title').textContent) ||
          title ||
          defaultTitle(url);
        mountWindow(node, id, url, t);
        if (options.replace) history.replaceState({ id: id, url: url }, '', url);
        else history.pushState({ id: id, url: url }, '', url);
        return node;
      })
      .finally(done);
  }

  function updateCartBadge() {
    return fetch(shopifyPath('cart.js'), { cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () {});
  }

  function initOpenTriggers() {
    document.addEventListener(
      'click',
      function (e) {
        var control = e.target.closest('.window-controls .window-button');
        if (control) {
          e.preventDefault();
          e.stopPropagation();
          handleWindowControlClick(control);
          return;
        }

        var trigger = e.target.closest('[data-open-url]');
        if (!trigger) return;

        e.preventDefault();
        e.stopPropagation();

        if (trigger.closest('.desktop-icons')) {
          document.querySelectorAll('.desktop-icons .icon').forEach(function (i) {
            i.classList.remove('is-selected');
          });
          trigger.classList.add('is-selected');
        }

        closeStartMenu();
        openWindow(
          trigger.getAttribute('data-open-url'),
          trigger.getAttribute('data-open-title') || ''
        );
      },
      true
    );
  }

  function closeStartMenu() {
    var menu = document.getElementById('start-menu');
    var btn = document.getElementById('start-button');
    if (menu) menu.classList.remove('is-open');
    if (btn) btn.classList.remove('is-active');
  }

  function initDrag() {
    function onStart(clientX, clientY, header) {
      var win = header.closest('.window');
      if (!win || win.classList.contains('is-maximized')) return;
      var id = win.id.replace('-window', '');
      setActive(id);
      var rect = win.getBoundingClientRect();
      var canvasRect = canvas.getBoundingClientRect();
      drag = {
        el: win,
        ox: clientX - rect.left,
        oy: clientY - rect.top,
        maxX: canvasRect.width - win.offsetWidth,
        maxY: canvasRect.height - win.offsetHeight
      };
    }

    function onMove(clientX, clientY) {
      if (!drag) return;
      var x = clientX - drag.ox - canvas.getBoundingClientRect().left;
      var y = clientY - drag.oy - canvas.getBoundingClientRect().top;
      drag.el.style.left = Math.max(0, Math.min(x, drag.maxX)) + 'px';
      drag.el.style.top = Math.max(0, Math.min(y, drag.maxY)) + 'px';
    }

    function onEnd() {
      drag = null;
    }

    canvas.addEventListener('mousedown', function (e) {
      var header = e.target.closest('.window-header');
      if (!header || e.target.closest('.window-controls')) return;
      onStart(e.clientX, e.clientY, header);
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      onMove(e.clientX, e.clientY);
    });

    document.addEventListener('mouseup', onEnd);

    canvas.addEventListener(
      'touchstart',
      function (e) {
        var header = e.target.closest('.window-header');
        if (!header || e.target.closest('.window-controls')) return;
        var t = e.touches[0];
        onStart(t.clientX, t.clientY, header);
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      function (e) {
        if (!drag) return;
        var t = e.touches[0];
        onMove(t.clientX, t.clientY);
        e.preventDefault();
      },
      { passive: false }
    );

    document.addEventListener('touchend', onEnd);
  }

  function initLinkCapture() {
    canvas.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-url]')) return;
      if (e.target.closest('.window-controls')) return;

      var a = e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var href = a.getAttribute('href');
      if (!href || href === '#' || href.indexOf('#') === 0) return;
      var url = new URL(a.href, location.origin);
      if (url.origin !== location.origin) return;
      if (url.pathname.indexOf('/checkout') === 0) return;
      e.preventDefault();
      openWindow(url.pathname, a.textContent.trim());
    });

    canvas.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (form.querySelector('[name="checkout"]') && e.submitter && e.submitter.name === 'checkout') return;
      if (form.getAttribute('action') && form.getAttribute('action').indexOf('/contact') !== -1) return;
      if (form.id === 'product-form') return;
      if (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart') !== -1) {
        e.preventDefault();
        e.stopPropagation();
        fetch(form.action || '/cart', {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin'
        }).then(function () {
          return updateCartBadge().then(function () {
            var cartId = urlToId('/cart');
            if (openWindows.has(cartId)) {
              return refreshWindowContent(cartId, '/cart');
            }
            return openWindow('/cart', 'Sepet');
          });
        });
      }
    });
  }

  function boot() {
    initOpenTriggers();
    initDrag();
    initLinkCapture();

    var initialUrl = document.body.getAttribute('data-initial-url') || location.pathname;
    var initialTitle = document.body.getAttribute('data-initial-title') || defaultTitle(initialUrl);
    var node = bootstrap ? (bootstrap.querySelector('.window') || bootstrap.firstElementChild) : null;
    if (node) node = node.cloneNode(true);

    var skipAutoOpen = isMobileView() && normalizeUrl(initialUrl) === '/';

    if (skipAutoOpen) {
      if (bootstrap) bootstrap.remove();
      updateMobileLauncher();
    } else if (node) {
      openWindow(initialUrl, initialTitle, node, { replace: true });
      if (bootstrap) bootstrap.remove();
    } else {
      openWindow(initialUrl, initialTitle, null, { replace: true });
    }

    updateCartBadge();

    window.addEventListener('resize', function () {
      if (!isMobileView()) {
        document.body.classList.remove('has-open-windows');
        var icons = document.querySelector('.desktop-icons');
        if (icons) icons.classList.remove('desktop-icons--dismissed');
        return;
      }
      openWindows.forEach(function (win) {
        layoutMobileWindow(win.el);
      });
      updateMobileLauncher();
    });

    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.url) openWindow(e.state.url, defaultTitle(e.state.url));
    });
  }

  document.addEventListener('submit', handleProductAddSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
